import styled from '@emotion/styled';

export const LoyaltyColor = styled('span')`
  color: ${({ theme }) => theme.color.loyalty.description || theme.color.brand};
`;
